import { Button } from "@mui/material";

const ExportButton = ({ onClick }) => {
  return (
    <Button
      variant="outlined"
      color="neutral"
      onClick={onClick}
      sx={{
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: "14px",
        border: "1px solid rgba(14, 41, 102, 1)",
        textTransform: "none",
        borderRadius: "10px",
        color: "rgba(14, 41, 102, 1)",
        py: 1,
      }}
    >
      Export
    </Button>
  );
};

export default ExportButton;
